import React from "react";
import Pagination from "react-bootstrap/Pagination";

const HRPagination = ({ totalPages, currentPage, setCurrentPage }) => {
  const createPaginationItems = () => {
    const paginationItems = [];

    if (totalPages <= 1) {
      return paginationItems;
    }

    let startPage = Math.max(currentPage - 2, 2);
    let endPage = Math.min(startPage + 2, totalPages - 1);

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => setCurrentPage((prevPage) => Math.max(prevPage - 1, 1))}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key="first"
        onClick={() => setCurrentPage(1)}
        active={currentPage === 1}
      >
        1
      </Pagination.Item>
    );

    if (startPage > 2) {
      paginationItems.push(
        <Pagination.Ellipsis key="start-ellipsis" disabled />
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          onClick={() => setCurrentPage(i)}
          active={currentPage === i}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages - 1) {
      paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    paginationItems.push(
      <Pagination.Item
        key="last"
        onClick={() => setCurrentPage(totalPages)}
        active={currentPage === totalPages}
      >
        {totalPages}
      </Pagination.Item>
    );

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() =>
          setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages))
        }
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  return <Pagination>{createPaginationItems()}</Pagination>;
};

export default HRPagination;
